import axios from 'axios';
import { API_HOST } from '../consts';

const fetchMaritalStatusOptions = async (params) => {
  const res = await axios.get(`${API_HOST}/persons/marital_status`, { params });
  return res.data;
};

export default fetchMaritalStatusOptions;
